import React from 'react';
import ReactDOM from 'react-dom';

import {AppFlags} from './app/app-types';
import App from './app/app';
import {slInterface} from './react-oe/sl-interface';
import OEToolbox from './lib/tools/oe-toolbox';
import ServiceWorkerTool from './lib/tools/service-worker-tool';

//import HelloWorld from './docu-samples/hello-world-1';

//
console.log(OEToolbox.versionString());

//
if(AppFlags.get().includes(AppFlags.pwaSW))   {
    ServiceWorkerTool.register('./sw.js', /*{scope: './'}*/)
}

//
slInterface.startUp();

//
ReactDOM.render(
    <App />,
    document.getElementById('root')
);